import {Table} from "react-bootstrap";
import PropTypes from "prop-types";
import {THead} from "./THead.jsx";
import {TBody} from "./TBody.jsx";

export const TableBase = ({tableInstance, addTh, addTd, hideSorting, sticky}) => {
    return (
        <Table variant={'light'} striped size={'sm'}
               hover>
            <THead
                sticky={sticky}
                hideSorting={hideSorting}
                addTh={addTh} tableInstance={tableInstance}/>
            <TBody addTd={addTd} tableInstance={tableInstance}/>
        </Table>
    )
}

TableBase.propTypes = {
    tableInstance: PropTypes.object.isRequired,
    addTh: PropTypes.func,
    addTd: PropTypes.func,
    hideSorting: PropTypes.bool,
    detailKey: PropTypes.string,
    sticky: PropTypes.bool,
}